// frontend/src/components/ProfileBlockEditors/WordCloudEditor.js
import React, { useState } from 'react';
import { PlusIcon, CloseIcon } from '../Icons';

const WordCloudEditor = ({ block, onChange }) => {
    const [newWord, setNewWord] = useState('');

    const handleAddWord = () => {
        if (newWord.trim()) {
            const words = Array.isArray(block.content?.words) ? block.content.words : [];
            onChange({
                ...block,
                content: {
                    ...block.content,
                    title: block.content?.title || '',
                    words: [...words, newWord.trim()]
                }
            });
            setNewWord('');
        }
    };

    const handleRemoveWord = (index) => {
        const words = block.content?.words || [];
        onChange({
            ...block,
            content: {
                ...block.content,
                words: words.filter((_, i) => i !== index)
            }
        });
    };

    const handleTitleChange = (title) => {
        onChange({
            ...block,
            content: {
                ...block.content,
                title
            }
        });
    };

    return (
        <div className="flex flex-col gap-4">
            <div>
                <label className="block text-label-large text-surface-onVariant mb-1">
                    Titel
                </label>
                <input
                    type="text"
                    value={block.content?.title || ''}
                    onChange={(e) => handleTitleChange(e.target.value)}
                    placeholder="z.B. Meine Eigenschaften"
                    className="md3-textfield-outlined w-full"
                />
            </div>

            <div>
                <label className="block text-label-large text-surface-onVariant mb-1">
                    Wörter hinzufügen
                </label>
                <div className="flex gap-2 mb-3">
                    <input
                        type="text"
                        value={newWord}
                        onChange={(e) => setNewWord(e.target.value)}
                        onKeyPress={(e) => e.key === 'Enter' && handleAddWord()}
                        placeholder="z.B. Abenteuerlustig"
                        className="md3-textfield-outlined flex-1 h-12"
                    />
                    <button
                        onClick={handleAddWord}
                        className="md3-icon-btn-filled w-12 h-12 rounded-xs"
                        title="Hinzufügen"
                    >
                        <PlusIcon />
                    </button>
                </div>

                {block.content?.words && block.content.words.length > 0 && (
                    <div className="flex flex-wrap gap-2 p-2 border border-outlineVariant rounded-lg bg-surface-containerLow">
                        {block.content.words.map((word, index) => (
                            <div
                                key={index}
                                className="md3-chip bg-primary-container text-primary-onContainer border-transparent pr-1 pl-3"
                            >
                                <span>{word}</span>
                                <button
                                    onClick={() => handleRemoveWord(index)}
                                    className="p-1 rounded-full hover:bg-black/10 transition-colors"
                                >
                                    <CloseIcon fontSize="small" />
                                </button>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
};

export default WordCloudEditor;
